// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.etwFormulaire" largeur-forumlaire="65"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;